export const SIDEBARS_TOP = [
    {
        icon : 'ic ic-home',
        title: 'Home',
        link : '/dashboard'
    },
    {
        icon : 'ic ic-persone',
        title: 'Profile',
        link : '/settings/profile'
    },
    // {
    //     icon : 'ic ic-list',
    //     title: 'Categories',
    //     link : '/categories'
    // },
    // {
    //     icon : 'ic ic-diagram',
    //     title: 'Tracker',
    //     link : '/personal-tracker'
    // },
    {
        icon : 'ic ic-eye',
        title: 'Live events',
        link : '/live-events'
    }
];

export const SIDEBARS_TOP_EXAM_PREP = [
    {
        icon : 'ic ic-home',
        title: 'Home',
        link : '/'
    },
    {
        icon : 'ic ic-persone',
        title: 'Profile',
        link : '/settings/profile'
    },
    // {
    //     icon : 'ic ic-list',
    //     title: 'Categories',
    //     link : '/categories'
    // },
    // {
    //     icon : 'ic ic-diagram',
    //     title: 'Tracker',
    //     link : '/personal-tracker'
    // },
    {
        icon : 'ic ic-eye',
        title: 'Live events',
        link : '/live-events'
    }
];

export const SIDEBARS_TOP_GUEST = [
    {
        icon : 'ic ic-home',
        title: 'Home',
        link : '/'
    },
    // {
    //     icon : 'ic ic-list',
    //     title: 'Categories',
    //     link : '/categories'
    // },
    {
        icon : 'ic ic-eye',
        title: 'Live events',
        link : '/live-events'
    }
];

export const SIDEBARS_BOTTOM = [
    {
        icon : 'ic ic-euro',
        title: 'Payments',
        link : '/settings/payments'
    },
    {
        icon : 'ic ic-persons',
        title: 'About Us',
        link : '/aboutus'
    },
    {
        icon : 'ic ic-evelope',
        title: 'Contact us',
        link : '/contactUs'
    },
    {
        icon : 'ic ic-exit',
        title: 'Log out',
        link : '/logout'
    }
];

export const SIDEBARS_BOTTOM_GUEST = [
    // {
    //     icon : 'ic ic-euro',
    //     title: 'Pricing',
    //     link : '/pricing'
    // },
    {
        icon : 'ic ic-persons',
        title: 'About Us',
        link : '/aboutUs'
    },
    {
        icon : 'ic ic-evelope',
        title: 'Contact us',
        link : '/contactUs'
    }

];


export const BUTTONS = [
    {
        title: 'Sign Up',
        link : '/signUp'
    },
    {
        title: 'Sign In',
        link : '/signIn'
    }

];



// WEBPACK FOOTER //
// ./src/constants/sideBar.js